module.exports = __webpack_public_path__ + "img/different-cuisines_0.04d0e8f9.jpg";